export const apiQueryRoot = ['wevo-access'] as const;

export interface CompanySyncOptions {
    companyId: number;
    syncUsers?: boolean;
    unsyncedOnly?: boolean;
}

export function normalizeCompanySyncRequest(request: number | CompanySyncOptions): {
    companyId: number;
    body: {
        syncUsers?: boolean;
        unsyncedOnly?: boolean;
    };
} {
    if (typeof request === 'number') {
        return {
            companyId: request,
            body: {},
        };
    }

    return {
        companyId: request.companyId,
        body: {
            syncUsers: request.syncUsers,
            unsyncedOnly: request.unsyncedOnly,
        },
    };
}

export function getInvalidateAdminUserQueryKeys() {
    return [
        [...apiQueryRoot, 'admin-users'],
        [...apiQueryRoot, 'database-users'],
        [...apiQueryRoot, 'admin-team-members'],
        [...apiQueryRoot, 'admin-identity-attention'],
    ] as const;
}

export function getInvalidateAdminCompanyQueryKeys(companyId: number) {
    return [
        [...apiQueryRoot, 'admin-companies'],
        [...apiQueryRoot, 'admin-company', companyId],
    ] as const;
}

export function getInvalidateAdminCompanySyncQueryKeys(companyId: number) {
    return [
        ...getInvalidateAdminCompanyQueryKeys(companyId),
        [...apiQueryRoot, 'admin-identity-attention'],
    ] as const;
}
